/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';

import { gql, useMutation } from '@apollo/client';

import { ModalForm } from '../../core-ui';
import { useShowApolloError } from '../../support/graphql/useShowApolloError';

import { SenderAddressForm } from './SenderAddressForm';

import {
  CreateSenderAddress,
  CreateSenderAddressVariables,
} from './__generated__/CreateSenderAddress';

const CREATE_ADDRESS = gql`
  mutation CreateSenderAddress($data: CreateSenderAddressInput!) {
    createSenderAddress(data: $data) {
      id
    }
  }
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  initialValues: { uid: string; fullName: string; forwardTo: string } | null;
  onSaved: () => void;
};

export function CreateSenderAddressDialog(props: Props) {
  const { isOpen, onClose, initialValues, onSaved } = props;
  const showApolloError = useShowApolloError();

  const [createAddress, { loading }] = useMutation<
    CreateSenderAddress,
    CreateSenderAddressVariables
  >(CREATE_ADDRESS, {
    onError: showApolloError,
    onCompleted: () => {
      onClose();
      onSaved();
    },
  });

  return (
    <ModalForm
      title={t('Create a Sending Address')}
      isOpen={isOpen}
      isSubmitting={loading}
      submitButtonText={t('Save')}
      onClose={onClose}
    >
      <SenderAddressForm
        initialValues={initialValues}
        onSubmit={(data) => {
          const { uid, fullName, forwardTo } = data;
          createAddress({
            variables: {
              data: { uid, domain: 'mymarket.org', fullName, forwardTo },
            },
          });
        }}
      />
    </ModalForm>
  );
}
